import type { Listing } from '@thevillages/schemas';

import { CurrencyPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';

import { RemoveTrailingSPipe } from '../../../pipes/remove-trailing-s/remove-trailing-s-pipe';
import { StateService } from '../../../services/state/state';
import { ListingDetailsFeatures } from '../features/features';

@Component({
  imports: [CurrencyPipe, ListingDetailsFeatures, RemoveTrailingSPipe],
  selector: 'app-listing-details-info',
  styleUrl: './info.css',
  templateUrl: './info.html',
})
export class ListingDetailsInfo {
  protected readonly stateService = inject(StateService);

  public readonly listing = input.required<Listing>();

  protected navPostMessage(): void {
    const _addressOriginal = this.listing().address;
    const _address = `${_addressOriginal.streetAddress}, ${_addressOriginal.locality}, ${_addressOriginal.region} ${_addressOriginal.postalCode}`;

    this.stateService.notifyParentOfStateChange('HF_EVENT:NAVIGATE_REQUEST', {
      address: _address,
      latitude: this.listing().geo.coordinates[1],
      longitude: this.listing().geo.coordinates[0],
    });
  }
}
